import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from './styled/Button';

const Hero = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/register');
  };

  const handleLearnMore = () => {
    navigate('/about');
  };

  return (
    <div className="hemp-bg-gradient py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center p-8 bg-gradient-to-br from-white to-hemp-green-50 rounded-2xl shadow-2xl">
          <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-6 tracking-tight drop-shadow-lg">
            {t('home.hero.title')}
          </h1>
          <p className="text-xl text-gray-800 mb-8 max-w-3xl mx-auto font-medium bg-white/80 px-4 py-2 rounded-lg">
            {t('home.hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center mt-4">
            <Button variant="primary" size="lg" className="text-lg px-8 py-4" onClick={handleGetStarted}>
              {t('home.hero.getStarted')}
            </Button>
            <Button variant="secondary" size="lg" className="text-lg px-8 py-4" onClick={handleLearnMore}>
              {t('home.hero.learnMore')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
